import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../filters';
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'qrScanner',
  components: {
    QrcodeStream
  },
  props: {
    function: {
      type: String,
      required: true
    },
    functionType: {
      type: String,
      required: true
    },
    parent: {
      type: Object,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    parentDialogVar: {
      type: String,
    }
  },
  data: function () {
    return {
      qrCodeManual: '',

    }
  },
  methods: {
    onDecode(content) {
      this.GetElementsByQrCode(content);
    },
    onInit(promise) {
      promise.then(() => {
        //console.log('QR Reader Successfully initilized! Ready for scanning now!')
      })
        .catch(error => {
          if (error.name === 'NotAllowedError') {
            this.errorMessage = 'Hey! I need access to your camera'
          } else if (error.name === 'NotFoundError') {
            this.errorMessage = 'Do you even have a camera on your device?'
          } else if (error.name === 'NotSupportedError') {
            this.errorMessage = 'Seems like this page is served in non-secure context (HTTPS, localhost or file://)'
          } else if (error.name === 'NotReadableError') {
            this.errorMessage = 'Couldn\'t access your camera. Is it already in use?'
          } else if (error.name === 'OverconstrainedError') {
            this.errorMessage = 'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?'
          } else {
            this.errorMessage = 'UNKNOWN ERROR: ' + error.message
          }
        })
    },
    searchQrManually() {
      this.GetElementsByQrCode(this.qrCodeManual);
    },
    GetElementsByQrCode(qrElementId) {
      if (!qrElementId) {
        //this.$alertMsg('Please scan QR Code again...', 3);
        return;
      }
        

      //console.log('qrElementId', qrElementId);
      if (this.functionType == 'get') {
        axios.get(this.function, {
          params: {
            qrCode: qrElementId,
            pageSize: 10000,
            page: 1,
            filterText: ''
          }
        }).then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.parent[this.model] = response.data.items;
            this.parent[this.parentDialogVar] = false;
          }
          else {
            this.$alertMsg(response.data);
          }
        }).catch(err => {
          this.$alertMsg(err.response.data);
        });
      } else if (this.functionType == 'post') {

      }
    },
  },
}
